import { getTrackingKey } from '@/utils/api'

import API from './base'

class MerchantApi extends API {
  /**
   *
   * @param merchantId
   * @param data
   * @returns {Promise<unknown>}
   */
  submitNps = (merchantId, data) => {
    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'MERCHANT-ID_instore-nps'),
      path: this.uri + `/${merchantId}/instore-nps`,
      data: {
        score: data?.score,
        comment: data?.comment,
        order_id: data?.orderId,
      },
    })
  }
}

export default new MerchantApi('/checkout/merchant')
